module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "p01"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ct"
  }, [_c('b', [_c('i', [_vm._v("Part One")])])]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("‘Rich with the spoils of time . . .’ "), _c('br'), _vm._v("Thomas Gray "), _c('br'), _c('i', [_vm._v("Elegy Written in a Country Churchyard")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-077fb7e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vinc_9781590208007_oeb_p01_r1.vue
// module id = 81
// module chunks = 0